import * as actionTypes from './actionTypes';
import admSvc from '../../axios-admsvc';
import {concatePortals, createSdkPortalObject, getEnabledPortalUrl} from '../../shared/utility';
import { SDK_ENABLE, SDK_PORTAL_LIST } from '../../shared/Constants';
import { fetchPortalConfigSuccess, fetchPortalConfigFailure } from './member';
import * as urls from '../../shared/ApplicationUrls';

//fetch portals
export const fetchAccountPortals = () => {
    // console.log("[Add Account Actions] Fetch Account Portals Start ");
    return dispatch => {
        dispatch(fetchAccountPortalsStart());
        admSvc.get(getEnabledPortalUrl(true,"/screens/AddAccount/"))
            .then(response => {
                let portals = response.data.portals;
                let localStorageSdkList = JSON.parse(localStorage.getItem(SDK_PORTAL_LIST));
                if(!localStorageSdkList){
                    if(SDK_ENABLE){
                        admSvc.get(urls.FETCH_PORTAL_CONFIG)
                        .then(portalResponse => {
                            if(portalResponse.data.payload){
                                dispatch(fetchPortalConfigSuccess(portalResponse.data.payload));
                                let sdkPortalList = createSdkPortalObject(portalResponse.data.payload);
                                let noOfDuplicatePortals = getNoOfDuplicatePortals(portals, sdkPortalList);
                                portals = concatePortals(portals, sdkPortalList, "addAccount");
                                dispatch(fetchAccountPortalsSuccess(portals, noOfDuplicatePortals));
                                dispatch(fetchAccountPortalsInfo(portals));
                            }
                        }).catch(error => {
                            dispatch(fetchPortalConfigFailure(error));
                            dispatch(fetchAccountPortalsSuccess(portals));
                            dispatch(fetchAccountPortalsInfo(portals));
                        });
                    }else{
                        dispatch(fetchPortalConfigFailure("SDK Portal Fetching is Disabled"));
                        dispatch(fetchAccountPortalsSuccess(portals));
                        dispatch(fetchAccountPortalsInfo(portals));
                    }
                }else{
                    let noOfDuplicatePortals = getNoOfDuplicatePortals(portals, localStorageSdkList);
                    portals = concatePortals(portals, localStorageSdkList, "addAccount");
                    dispatch(fetchAccountPortalsSuccess(portals, noOfDuplicatePortals));
                    dispatch(fetchAccountPortalsInfo(portals));
                }
            })
            .catch(error => {
                // console.log("[Reference Data] Fetch Portals Error: ", error);
                dispatch(fetchAccountPortalsFailure(error));
                // return Promise.reject(error.response);
                return error.response;
            });
    }
}

export const getNoOfDuplicatePortals = (portalList, sdkPortalList) => {
    return portalList.filter(portal => sdkPortalList.some(sdkPortal => sdkPortal.portalShortName === portal.portalShortName)).length;
}

export const fetchAccountPortalsStart = () => {
    return {
        type: actionTypes.FETCH_ACCOUNT_PORTALS_START
    }
}

export const fetchAccountPortalsSuccess = (portals, noOfDuplicatePortals) => {
    // console.log("[Reference Data] Fetch Account Portals Success: ", portals);
    return {
        type: actionTypes.FETCH_ACCOUNT_PORTALS_SUCCESS,
        portals: portals.sort((a, b) => (a.portalDisplayName > b.portalDisplayName) ? 1 : -1),
        noOfDuplicatePortals: noOfDuplicatePortals || 0
    }
}

export const fetchAccountPortalsFailure = (error) => {
    return {
        type: actionTypes.FETCH_ACCOUNT_PORTALS_FAILURE,
        error: error
    }
}


// fetch portal Info
export const fetchAccountPortalsInfo = (portals) => {
    return dispatch => {
        portals.filter(portal => portal.prtlId).map(portal => (dispatch(fetchPortalInfo(portal.prtlId))));
    }
}

export const fetchPortalInfo = (portalId) => {
    return dispatch => {
        // dispatch(fetchPortalInfoStart());
        admSvc.get('/portals/'+portalId).then(response => {
            // console.log("[AddAccount] Fetch Portal Info Response: ",response.data);
            dispatch(fetchPortalInfoSuccess(response.data));
        }).catch(error => {
            // console.log("[AddAccount] Fetch Portal Info Error: ", error);
            dispatch(fetchPortalInfoFailure(error));
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

// export const fetchPortalInfoStart = () => {
//     return {
//         type: actionTypes.FETCH_ACCOUNT_PORTALS_START
//     }
// }

export const fetchPortalInfoSuccess = (portalInfo) => {
    return {
        type: actionTypes.FETCH_ACCOUNT_PORTAL_INFO_SUCCESS,
        portalInfo: portalInfo
    }
}

export const fetchPortalInfoFailure = (error) => {
    return {
        type: actionTypes.FETCH_ACCOUNT_PORTAL_INFO_FAILURE,
        error: error
    }
}


// add bank account
export const addBankAccount = (memberInfo) => {
    return dispatch => {
        dispatch(fetchFaroIdStart());
        const ahsRequest = {
            "firstName": memberInfo.FirstName,
            "lastName": memberInfo.LastName,
            "zipCode": memberInfo.ZipCode,
            "dateOfBirth": memberInfo.DOB,
            "ssn": memberInfo.SSN,
            "employeeId": memberInfo.SubscriberId,
            "filterDetails":true
        };
        admSvc.post("/members/external", ahsRequest,).then(response => {
            //console.log("[AddAccount] AHS Search Response: ",response.data);
            if(response.data.faroId) {
                dispatch(fetchFaroIdSuccess(response.data.faroId));
                dispatch(addAccount({...memberInfo, subscriberId: response.data.faroId}));
            } else if(response.data.status === 'error') {
                dispatch(fetchFaroIdFailure("No user found in Optum Bank."));
            } else {
                dispatch(fetchFaroIdFailure("It took longer than expected to validate the user. Pls try again."));
            }
        }).catch(error => {
            //console.log("[AddAccount] Error during AHS Search: ", error);
            dispatch(fetchFaroIdFailure(error));
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const fetchFaroIdStart = () => {
    return {
        type: actionTypes.FETCH_ACCOUNT_FARO_ID_START
    }
}

export const fetchFaroIdSuccess = (faroId) => {
    return {
        type: actionTypes.FETCH_ACCOUNT_FARO_ID_SUCCESS,
        faroId: faroId
    }
}

export const fetchFaroIdFailure = (error) => {
    return {
        type: actionTypes.FETCH_ACCOUNT_FARO_ID_FAILURE,
        error: error
    }
}

// add MYUHC sub portals account
export const addMyuhcSubPrtlAccount = (memberInfo) => {
    return dispatch => {
        dispatch(fetchMyuhcGroupIdStart());
        const myuhcMemberDataRequest = {
            "firstName": memberInfo.FirstName,
            "lastName": memberInfo.LastName,
            "dob": memberInfo.DOB,
            "zipCode" : memberInfo.ZipCode,
            "memberId": memberInfo.SubscriberId,
            "portalIndicator": memberInfo.portalIndicator,
            "parentPortal": memberInfo.targetPortal
         };
         delete memberInfo["portalIndicator"];

        admSvc.post("/members/fetch/groupId", myuhcMemberDataRequest,).then(response => {
            //console.log("[AddAccount] MYUHC Sub portal Search Response: ",response.data);
            if(response.data.groupId) {
                dispatch(fetchMyuhcGroupIdSuccess(response.data.groupId));
                dispatch(addAccount({...memberInfo, GroupId: response.data.groupId}));
            } else if(response.data.status === 'error') {
                dispatch(fetchMyuhcGroupIdFailure(response.data.msg));
            } else {
                dispatch(fetchMyuhcGroupIdFailure("It took longer than expected to validate the user. Pls try again."));
            }
        }).catch(error => {
            //console.log("[AddAccount] Error during MYUHC Sub portal Search: ", error);
            dispatch(fetchMyuhcGroupIdFailure("No user found."));
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const fetchMyuhcGroupIdStart = () => {
    return {
        type: actionTypes.FETCH_ACCOUNT_GROUP_ID_START
    }
}

export const fetchMyuhcGroupIdSuccess = (faroId) => {
    return {
        type: actionTypes.FETCH_ACCOUNT_GROUP_ID_SUCCESS,
        faroId: faroId
    }
}

export const fetchMyuhcGroupIdFailure = (error) => {
    return {
        type: actionTypes.FETCH_ACCOUNT_GROUP_ID_FAILURE,
        error: error
    }
}

// add account
export const addAccount = (memberInfo) => {
    return dispatch => {
        dispatch(addAccountStart());
        admSvc.post("/addAccount", memberInfo).then(response => {
            //console.log("[AddAccount] AddAccount Response: ",response.data);
            if(response.data.status.code === "200"){
                // this.setState({loading: false, success: {message: "Account created successfully."}});
                dispatch(addAccountSuccess());
            }else{
                // this.setState({loading: false, error: {message: "Record already Exists."}});
                dispatch(addAccountFailure({message: "Record already exists."}));
            }
        }).catch(error => {
           //console.log("[AddAccount] Error during AddAccount: ", error);
            // this.setState({loading: false, error: {message: "API call failed"}});
            dispatch(addAccountFailure({message: "Add account failed. Pls try again"}));
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const addAccountStart = () => {
    return {
        type: actionTypes.ADD_ACCOUNT_START,
    }
}

export const addAccountSuccess = () => {
    return {
        type: actionTypes.ADD_ACCOUNT_SUCCESS,
    }
}

export const addAccountFailure = (error) => {
    return {
        type: actionTypes.ADD_ACCOUNT_FAILURE,
        error: error
    }
}

export const setDisplayMessage = (message) => {
    return {
        type: actionTypes.SET_DISPLAY_MESSAGE,
        message: message
    }
}

export const setSuperUserDisplayMessage = (message) => {
    return {
        type: actionTypes.SET_SUPER_USER_DISPLAY_MESSAGE,
        message: message
    }
}

export const setAddAccountPortal = (portalInfo) => {
    return {
        type: actionTypes.SET_ADD_ACCOUNT_PORTAL,
        portalInfo: portalInfo
    }
}
